import { Injectable } from '@angular/core';
import { Observable, fromEvent, merge, Subject, timer, Subscription, BehaviorSubject } from 'rxjs';
import * as moment from 'moment';
import * as _lodash from 'lodash';
import { CookieService } from 'ngx-cookie-service';
@Injectable({
  providedIn: 'root'
})
export class IdleTimeoutService {

  public userEvents: Observable<any> = new Observable();
  private idleTimer: Subscription = new Subscription();
  private idleTimeOutMilliSeconds: number = 60 * 1000;
  public idleSessionExpired: Subject<boolean> = new Subject<boolean>();
  public sessionExpireMinRemaining = new BehaviorSubject(60);
  private DOMAIN: string = 'domain=.toyota.com; ';
  private readonly DD365_SESSION_COOKIE_NAME = 'DDSessionTimer';
  private readonly FORGEROCK_COOKIE_NAME = 'iPlanetDirectoryPro';
  private readonly PATH = '/';
  private localhostTime: any;
  private sessionIdleWarningTimeInMin = 50;

  constructor(private cookieService: CookieService) {}


  public initiateIdleTimer(timeOutSeconds: number): Observable<any> {
    this.userEvents = merge(
      fromEvent(document, 'click'),
      fromEvent(document, 'dblclick'),
      fromEvent(document, 'contextmenu'),
      fromEvent(document, 'drag'),
      fromEvent(document, 'scroll'),
      fromEvent(document, 'mousewheel'),
      fromEvent(document, 'keydown'),
      fromEvent(document, 'mousedown'),
      fromEvent(document, 'keypress'),
      fromEvent(document, 'DOMMouseScroll'),
      fromEvent(document, 'touchmove'),
      fromEvent(document, 'MSPointerMove')
    );

    this.idleTimeOutMilliSeconds = timeOutSeconds * 1000;
    this.startIdleTimer();

    return this.idleSessionExpired;
  }

  private startIdleTimer() {
    const dateString = moment.utc().format("MM/DD/YYYY HH:mm:ss").toString();
    const cookieString = `${this.DD365_SESSION_COOKIE_NAME}=${dateString};${this.DOMAIN}path=${this.PATH};`;
    document.cookie = cookieString;

    if (document.location.hostname.toLowerCase().includes('localhost')) {
      this.localhostTime = moment.utc().format("MM/DD/YYYY HH:mm:ss");
      console.log('CON SESSION ************ TIME SET LOCALHOST ********************************** ', this.localhostTime);
    } else {
      console.log('CON SESSION ************ TIME SET ********************************** ', dateString);
    }
    
    this.idleTimer = timer(this.idleTimeOutMilliSeconds, this.idleTimeOutMilliSeconds).subscribe((res) => {
      this.idleSessionExpired.next(true);
    });
  }

  deleteDDSessionTimerCookie() {
    document.cookie = `${this.DD365_SESSION_COOKIE_NAME}=;${this.DOMAIN}path=${this.PATH};`;
  }

  public resetIdleTimer() {
      this.idleTimer.unsubscribe();
      this.startIdleTimer();
  }

  public stopIdleTimer() {
    this.idleTimer.unsubscribe();
  }


  public isForgerockCookieExit() {
    let isForgerockCookieExit = null;
    if (document.location.hostname.toLowerCase().includes('localhost')) {
      isForgerockCookieExit = "true";
    } else {
      isForgerockCookieExit = this.cookieService.get(this.FORGEROCK_COOKIE_NAME) === '' ? null : this.cookieService.get(this.FORGEROCK_COOKIE_NAME);
    }
    return isForgerockCookieExit;
  }

  // if this is less than 5 minutes CON needs to show alert to user
  public userSessionRemaining() {

    let lastActivetAt = this.cookieService.get(this.DD365_SESSION_COOKIE_NAME);

    if (document.location.hostname.toLowerCase().includes('localhost')) {
      lastActivetAt = this.localhostTime;
    }

    let remainingTime = 0;

    if (lastActivetAt && lastActivetAt !== '') {
      const sessionCookieTime = Date.parse(lastActivetAt);
      const utcTime = Date.parse(moment.utc().format("MM/DD/YYYY HH:mm:ss"));
      const lastActiveInSec = (utcTime - sessionCookieTime) / 1000;
      const lastActiveInMin = lastActiveInSec / 60;
      remainingTime = (10 - (lastActiveInMin - this.sessionIdleWarningTimeInMin));
      remainingTime = Number.parseInt(remainingTime.toString());
      console.log('CON SESSION ************ CURRENT UTC ********************************** ', moment.utc().format("MM/DD/YYYY HH:mm:ss"));
      console.log('CON SESSION ************ TIME REMAINING ********************************** ', remainingTime);
      this.sessionExpireMinRemaining.next(remainingTime);
      return remainingTime;
    }

    return remainingTime;
  }

  private getCookieValue(cookieName: string) {
    const decodedCookie = decodeURIComponent(document.cookie);
    const allCookies = decodedCookie?.split(';');
    let cookieValue = allCookies?.find(c => c?.trim()?.indexOf(`${cookieName}=`) == 0);
    cookieValue = cookieValue?.trim()?.slice(`${cookieName}=`.length)?.replace(';','');
    return cookieValue;
  }

}